<section
  class="flex h-full w-full flex-col overflow-hidden bg-white text-gray-900"
  role="dialog"
  [attr.aria-label]="'channel_types_title' | translate"
>
  <header class="flex shrink-0 items-center gap-3 border-b border-gray-100 px-4 py-3">
    <h2 class="m-0 flex-1 text-base font-bold leading-6 text-gray-900">{{ 'channel_types_title' | translate }}</h2>
    <button
      type="button"
      class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100"
      [attr.aria-label]="'close' | translate"
      (click)="cancel()"
    >
      <app-icon>close</app-icon>
    </button>
  </header>

  <div class="crm-scroll min-h-0 flex-1 overflow-y-auto bg-gray-50 px-4 py-4">
    @if (isLoading) {
      <div class="flex min-h-48 items-center justify-center">
        <app-loader size="small" />
      </div>
    } @else if (!groups.length) {
      <div class="flex min-h-48 flex-col items-center justify-center gap-2 rounded-xl bg-white px-4 py-8 text-center">
        <app-icon class="text-gray-300">hub</app-icon>
        <p class="m-0 text-sm font-medium text-gray-600">{{ 'channel_types_empty' | translate }}</p>
      </div>
    } @else {
      @for (group of groups; track group.key) {
        <div class="mb-5 last:mb-0">
          <div class="mb-2 flex items-center gap-2">
            <span class="text-xs font-semibold uppercase tracking-wide text-gray-400">{{ group.title | translate }}</span>
            <span class="h-px flex-1 bg-gray-200"></span>
          </div>

          <div class="grid grid-cols-2 gap-3 sm:grid-cols-3">
            @for (option of group.items; track option.value) {
              <button
                type="button"
                class="flex min-w-0 flex-col items-center gap-3 rounded-xl border bg-white px-3 py-4 text-center shadow-sm disabled:cursor-not-allowed disabled:opacity-50"
                [ngClass]="
                  isSelected(option)
                    ? 'border-[var(--primary-color)] bg-[rgba(var(--primary-color-rgb-code),0.08)]'
                    : 'border-gray-200 enabled:hover:bg-gray-50'
                "
                [disabled]="option.disabled"
                [title]="option.name | translate"
                (click)="selectType(option)"
              >
                @if (option.img) {
                  <img [src]="option.img" [alt]="option.name | translate" class="h-10 w-10 shrink-0 object-contain" />
                } @else {
                  <app-icon class="text-gray-300">hub</app-icon>
                }
                <span class="min-w-0 max-w-full truncate text-sm font-semibold text-gray-700">{{ option.name | translate }}</span>
              </button>
            }
          </div>
        </div>
      }
    }
  </div>
</section>
